import { Link, StackProps, Text, VStack } from '@elkaso-app/web-design';

export interface IPocCallDetailsCell extends StackProps {
  callId: string;
  callStatus: string;
  durationMs: number;
  callCost: {
    combinedCost: number;
  };
  recordingsUrl: string;
  ingestedAt: string;
}

export const PocCallDetailsCell = ({
  callId,
  callStatus,
  durationMs,
  callCost,
  recordingsUrl,
  ingestedAt,
  ...rest
}: IPocCallDetailsCell) => {
  return (
    <VStack spacing='sm' align='start' {...rest}>
      <VStack spacing='xs'>
        <Link target='_blank' title={callId} href={recordingsUrl}>
          <Text
            whiteSpace='pre-line'
            alignSelf='flex-start'
            color={'red.500'}
            fontWeight='500'
            _hover={{ color: 'red.500' }}
            _focus={{ color: 'red.500' }}>
            Recording URL
          </Text>
        </Link>
        <audio controls>
          <source src={recordingsUrl} type='audio/wav' />
          Your browser does not support the audio element.
        </audio>
      </VStack>

      <Text
        whiteSpace='pre-line'
        fontSize='lg'
        bg={
          callStatus === 'ended'
            ? 'green.100'
            : callStatus === 'failed'
            ? 'red.100'
            : callStatus === 'error'
            ? 'blue.100'
            : 'gray.100'
        }
        color={
          callStatus === 'ended'
            ? 'green.700'
            : callStatus === 'failed'
            ? 'red.700'
            : callStatus === 'error'
            ? 'blue.700'
            : 'gray.700'
        }
        fontWeight='600'
        px='3'
        py='1'
        borderRadius='md'
        display='inline-block'>
        {callStatus.charAt(0).toUpperCase() + callStatus.slice(1)}
      </Text>

      <Text whiteSpace='pre-line' fontSize='md' color='gray.500'>
        {`Duration: ${Math.floor(durationMs / 1000 / 60)}m ${Math.floor((durationMs / 1000) % 60)}s`}
      </Text>

      <Text whiteSpace='pre-line' fontSize='md' color='gray.500'>
        {`Cost: $${(callCost.combinedCost / 100).toFixed(2)}`}
      </Text>

      <Text whiteSpace='pre-line' fontSize='md' color='gray.500'>
        {`${new Date(ingestedAt).toLocaleString('en-US', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })}`}
      </Text>
    </VStack>
  );
};
